module.exports = __webpack_public_path__ + "static/media/boy-standing.9e3c9526.png";